import { Endpoints } from '@config/Endpoints';
import { customAxios } from '@infrastructure/api/CustomAxios';

export const InvitationResource = {
  getInvitation: (invitationId: string) => {
    return customAxios.get(Endpoints.recipient.invitation(invitationId));
  },
};
